module.exports = new __parcel__URL__("beetlejuice-michael-keaton.d04a3e15.gif").toString();